


















































import {mixins}          from 'vue-class-component';
import {Component, Prop} from 'vue-property-decorator';
import BarIcon           from '@/components/svg/BarIcon.vue';
// import LoginForm          from '@/components/LoginForm.vue';
import Logo              from '@/components/svg/Logo.vue';
// import LogoutForm         from '@/components/LogoutForm.vue';
import UsernameContainer from '@/components/UsernameContainer.vue';
import MainMixin         from '@/mixins/Main';

@Component({
    components: {
        UsernameContainer,
        BarIcon,
        Logo
    },
    name: `NavComponent`
})
export default class NavComponent extends mixins(MainMixin)
{
    @Prop({required: true, type: Array}) public readonly links!: any[];
    @Prop({required: true, type: Object}) public readonly sections!: any;

    public barIconClickOn(): void
    {
        this.$store.commit(`set`, {props: {navVisible: !this.visible}});
    }

    public async categoryChangeOn($event: Merge<InputEvent, { target: HTMLSelectElement }>): Promise<void>
    {
        const {commit, dispatch, getters} = this.$store;

        const categoryOldName = this.categories[this.categoriesActive].name;

        const categoryNewName = this.categories[$event.target.value].name;
        const category = new this.$String(categoryNewName).urlTo();

        const name: string = (this.$route.name as string).replace(
            new RegExp(`${new this.$String(categoryOldName).capitalize()}$`, ``),
            new this.$String(categoryNewName).capitalize().toString()
        );

        this.$router.push({
            name: this.$router.resolve({name}).resolved.matched.length > 0 ? name : this.sectionsActive,
            params: {...getters.params, category}
        }).catch((err) =>
        {
            console.error(err);
        });

        await dispatch(`categoriesActiveSet`, parseInt($event.target.value)).catch((err) =>
        {
            console.error(err);
        });
        setTimeout(() =>
        {
            commit(`dataLoadedSet`, {nestedValues: [this.categoriesActive, this.$store.state.leagueSeasons.active, this.$store.state.divisions.active]});
        }, 50);
    }

    public clickOn($event: Merge<MouseEvent, { target: HTMLElement }>): void
    {
        if ($event.target.closest(`.categories-select`))
        {
            return;
        }

        this.$store.commit(`set`, {props: {keyMode: `nav`}});
    }

    public async linkClickOn(): Promise<void>
    {
        const {commit, getters} = this.$store;

        if (getters.touchscreen)
        {
            commit(`set`, {props: {navVisible: false}});
        }
    }

    public get categories(): any
    {
        return this.$store.state.categories.value;
    }

    public get userLogged()
    {
        return this.$store.state.userLogged;
    }

    public get visible(): boolean
    {
        return this.$store.state.navVisible;
    }
}
